
import { Vue, Component } from 'vue-property-decorator';
import Uploader from '@/components/next/Uploader.vue';
import qs from 'qs';
import { save } from '../api';
import { isWeiXin } from '@/common/ts/common';
import {
  Field,
  Cell,
  CellGroup,
  Toast,
  Calendar,
  Popup,
  Picker,
  RadioGroup,
  Radio,
  Checkbox,
  Button,
} from 'vant';
Vue.use(Field)
  .use(Cell)
  .use(CellGroup)
  .use(Popup)
  .use(Picker)
  .use(RadioGroup)
  .use(Radio)
  .use(Checkbox)
  .use(Button)
  .use(Calendar);
@Component({
  components: {
    Uploader,
  },
})
export default class Save extends Vue {
  name: string = '';
  chinaId: string = '';
  otherName: any = [];
  phone: string = '';
  title: string = '';
  socName: string = '';
  email: string = '';
  teacher: string = '';
  ifMaterial: string = '1';
  material: any = [];
  materialCover: any = [];
  introduction: string = '';
  url: string = '';
  imgSrc: any = [];
  soc: string = '1';
  checked: boolean = false;
  checkedShow: boolean = false;
  messageShow: boolean = false;
  unionid: string | null = '';
  workType: string = '平面类';
  columns: any = ['平面类', '视频类', '互动类'];
  showPicker: boolean = false;
  downLoadUrl: string =
    'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
  async uploadImg() {
    this.imgSrc = (await (this.$refs
      .uploader as Uploader).uploadToOss()) as string[];
  }
  async uploadVideo() {
    this.imgSrc = (await (this.$refs
      .uploader as Uploader).uploadToOss()) as string[];
  }
  async uploadMaterialCover() {
    this.materialCover = (await (this.$refs
      .uploaders as Uploader).uploadToOss()) as string[];
  }
  async mounted() {
    this.unionid = window.localStorage.getItem('unionid');
    if (!this.unionid && isWeiXin()) {
      this.WechatLogin();
    } else if (window.udid) {
      this.AppLogin();
    }
  }
  addothers() {
    const item = [{name: '姓名', value: ''}, {name: '身份证号', value: ''} ];
    this.otherName.push(item);
  }
  addMaterial() {
    const items = [{name: '素材出处', value: ''}];
    this.material.push(items);
  }
  raidMessage() {
    this.checked = true;
    this.messageShow = false;
  }
  onConfirm(value: any) {
    this.workType = value;
    this.showPicker = false;
  }
  formatDate(date: any) {
    return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
  }
  AppLogin() {
    const token = window.gettoken();
    if (token === 'null' || !token) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return;
    }
  }
  ShowMessage() {
    this.checkedShow = true;
    this.messageShow = true;
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  async submit() {
    if (!isWeiXin() && !window.udid) {
      this.$dialog
        .confirm({
          title: '友情提示',
          message: '请在上游新闻App进行投票',
          confirmButtonText: '还没装？一步安装',
          cancelButtonText: '我已安装过',
          closeOnClickOverlay: true,
        })
        .then((action) => {
          console.log(action);
          window.location.href = this.downLoadUrl;
        })
        .catch((action) => {
          console.log(action);
          if (action === 'overlay') {
            // 忽略掉点击遮罩层的关闭行为
            return;
          }
        });
      return;
    } else if (!this.checked) {
      Toast('请阅读并同意版权说明！');
      return false;
    } else if (!this.title) {
      Toast('请填写作品名称！');
      return false;
    } else if (!this.name) {
      Toast('请填写参赛人/主创！');
      return false;
    } else if (!this.chinaId) {
      Toast('请填写身份证号！');
      return false;
    } else if (!this.phone) {
      Toast('请填写联系电话！');
      return false;
    } else if (!/^1[345789][0-9]{9}$/.test(this.phone)) {
      Toast('电话号码格式错误！');
      return false;
    } else if (!this.email) {
      Toast('请填写邮箱！');
      return false;
    } else if (!this.introduction) {
      Toast('请填写作品简介及创意亮点！');
      return false;
    } else if (!this.imgSrc.length) {
      Toast('请上传作品！');
      return false;
    } else if (this.workType === '互动类' && !this.url) {
      Toast('请填写作品链接！');
      return false;
    } else {
      let str: any = '';
      this.otherName.map((item: any, indexAll: any) => {
        item.map((item2: any, index: number) => {
          const strs = (index + 1) % 2 === 1 ? ',' : '|';
          if (indexAll < this.otherName.length - 1 ) {
              str += item2.value + strs;
          } else {
            if (index === 0) {
              str += item2.value + strs;
            } else {
              str += item2.value;
            }
          }
        });
      });
      let matStr: any = '';
      this.material.map((item: any, index: any) => {
          const strs = '|';
          if (item[0].value !== '') {
            if (index < this.material.length - 1) {
               matStr += item[0].value + strs;
            } else {
               matStr += item[0].value;
            }
          }
      });
      const data = {
        work_type: this.workType,
        name: this.name,
        chinaId: this.chinaId,
        other_name: str,
        phone: this.phone,
        title: this.title,
        soc: this.soc,
        soc_name: this.socName,
        email: this.email,
        teacher: this.teacher,
        introduction: this.introduction,
        cover: this.imgSrc.join('|'),
        if_material: this.ifMaterial,
        material: matStr,
        material_cover: this.materialCover.join('|'),
        url: this.url,
        unionid: this.unionid,
        token: window.gettoken(),
        appkey: window.appkey,
        udid: window.udid,
      };
      const res: any = await save(data);
      if (res.code === 200) {
        Toast(`${res.msg}`);
        setTimeout(() => {
          this.$router.go(0);
        }, 2000);
      } else {
        Toast(`${res.msg}`);
      }
    }
  }
}
